"use client"

interface XpBarProps {
  current: number
  toNextLevel: number
  level: number
  heroType: string
  scale: number
  variant?: "game" | "shop"
}

export const XpBar = ({ current, toNextLevel, level, heroType, scale, variant = "game" }: XpBarProps) => {
  const percent = toNextLevel > 0 ? (current / toNextLevel) * 100 : 100

  const width = 112 * scale
  const height = 14 * scale
  // Shop variant has slightly different positioning
  const left = variant === "game" ? 128 * scale : 122 * scale
  const top = 91 * scale

  const barId = variant === "game" ? "xp-bar" : "shop-xp-bar"

  // Game variant shows hero type, shop variant shows only level
  const label = variant === "game" ? `Lv ${level} ${heroType}` : `Lv ${level}`

  return (
    <div
      id={barId}
      className="absolute overflow-hidden"
      style={{
        left,
        top,
        width,
        height,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        borderRadius: 2 * scale,
      }}
    >
      <div className="h-full bg-purple-600 transition-all duration-200" style={{ width: `${percent}%` }} />
      <span
        className="absolute inset-0 flex items-center justify-center text-white font-bold drop-shadow-lg"
        style={{
          fontSize: Math.max(6, 8 * scale),
          textShadow: "0 1px 2px black",
        }}
      >
        {label}
      </span>
    </div>
  )
}
